import { mapGetters } from 'vuex';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    href: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
  },
};



// WEBPACK FOOTER //
// ./src/components/insight/insight-link/insight-link.js